import { ref, computed, nextTick } from 'vue'

/**
 * 通用数据获取与状态管理组合式函数
 * @param {Function} fetchFn - 实际的数据获取函数（需要返回Promise）
 * @param {any} defaultData - 数据默认值
 * @returns {Object} 包含状态和操作方法的对象
 */
export function useFetch(fetchFn, defaultData = null) {
  // 状态管理
  const data = ref(defaultData)
  const isLoading = ref(false)
  const error = ref('')
  const isSuccess = computed(() => !isLoading.value && !error.value && data.value !== null)

  // 执行数据获取
  const execute = async (...args) => {
    // 防止重复请求 + 强制重置为加载中
    if (isLoading.value) return;
    isLoading.value = true; // 强制设为 true，确保初始状态正确
    error.value = '';

    try {
      const result = await fetchFn(...args);
      data.value = result;
      return result;
    } catch (err) {
      error.value = err.message || '获取数据失败，请稍后重试';
      console.error('数据获取失败:', err);
      throw err;
    } finally {
      // 无论成功/失败，强制延迟 300ms 再关闭（避免加载闪一下）
      // 关键：用 nextTick 确保响应式更新生效
      await nextTick();
      isLoading.value = false;
    }
  };

  // 重置数据
  const reset = () => {
    data.value = defaultData
    error.value = ''
    isLoading.value = false
  }

  return {
    data,
    isLoading,
    error,
    isSuccess,
    execute,
    reset
  }
}
